import {
    CLEAR_ORDER,
    SET_ACTIVE_ORDER_BEFORE,
    SET_ACTIVE_ORDER_NOW,
    SET_MEAN_TIME,
    SET_ORDER, SET_ORDER_ITEM
} from "../actions/order_actions";

const  initialState = {
    order_items: [],
    express: 0,
    priming: 0,
    ready_order_price: 0,
    payment_order: 0,
    mean_time: 0,
    active_order_now: 0,
    active_order_before: 0,
};

export function orderReducer(state  = initialState,action) {
    switch (action.type) {
        case SET_ORDER:{
            let flag = true;
            let orders = state.order_items;
            orders.forEach(item =>{
                if (Number(item.orderid) === Number(action.payload.orderid))
                    flag = false;
            });
            if (flag) {
                let express = state.express;
                let priming = state.priming;
                let ready_order_price = state.ready_order_price;
                let payment_order = state.payment_order;
                if (action.payload.status.status > 4) {
                    ready_order_price += action.payload.price
                }
                return {
                    ...state,
                    express: express + action.payload.express,
                    priming: priming + action.payload.priming,
                    ready_order_price: ready_order_price,
                    payment_order: payment_order + action.payload.price
                };
            }
            return {...state};
        }
        case SET_ORDER_ITEM:{
            let orders = state.order_items;
            orders = orders.filter(item =>{
                return Number(item.orderid) !== Number(action.payload.orderid)
            });
            orders.push(action.payload);
            return {...state, order_items: orders}
        }
        case CLEAR_ORDER:{
            return {...state,
                meant_time: 0,
            };
        }
        case SET_MEAN_TIME:{
            return {...state, mean_time: action.payload};
        }
        case SET_ACTIVE_ORDER_BEFORE:{
            return {...state, active_order_before: action.payload};
        }
        case SET_ACTIVE_ORDER_NOW:{
            return {...state, active_order_now: action.payload};
        }
        default:
            return {...state};
    }
}
